import { atom } from 'recoil';

export const chatFloatingOpenState = atom<boolean>({
  key: 'chatFloatingOpenState',
  default: false,
});


/** Chat 전용 검색 상태 — 전역 searchValueState와 분리 */
export const chatSearchValueState = atom<string>({
  key: 'chatSearchValueState',
  default: '',
});
